module.exports = __webpack_public_path__ + "static/media/german-blog.046fcf46.png";